<template>
  <div class="about-page page-wrapper">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">大会介绍</h1>
        <p class="page-subtitle">Conference Introduction</p>
      </div>
    </div>

    <div class="page-content">
      <div class="container">
        <!-- 会议概述 -->
        <section class="about-section">
          <h2 class="section-title">会议概述</h2>
          <div class="about-intro">
            <div class="intro-content">
              <p> {{ conferenceInfo.content }}</p>
            </div>
            <div class="intro-stats">
                          <div class="stat-item">
                <div class="stat-value">{{ conferenceInfo.attendees }}</div>
                <div class="stat-label">参会人数</div>
              </div>
              <div class="stat-item">
                <div class="stat-value">{{ conferenceInfo.reports }}</div>
                <div class="stat-label">学术报告</div>
              </div>
              <div class="stat-item">
                <div class="stat-value">{{ conferenceInfo.experts }}</div>
                <div class="stat-label">特邀专家</div>
              </div>
              <div class="stat-item">
                <div class="stat-value">{{ conferenceInfo.days }}</div>
                <div class="stat-label">天精彩日程</div>
              </div>
            </div>
          </div>
        </section>

        <!-- 基本信息 -->
        <section class="about-section">
          <h2 class="section-title">基本信息</h2>
          <div class="info-cards">
            <div class="info-card">
              <div class="info-icon"><i class="el-icon-date"></i></div>
              <div class="info-content">
                <h4>会议时间</h4>
                <p>{{ formatConferenceDate(conferenceInfo.start_date, conferenceInfo.end_date) }}</p>
              </div>
            </div>
            <div class="info-card">
              <div class="info-icon"><i class="el-icon-location-outline"></i></div>
              <div class="info-content">
                <h4>会议地点</h4>
                <p v-html="conferenceInfo.location.replace('\\n', '<br/>')"></p>
              </div>
            </div>
            <div class="info-card">
              <div class="info-icon"><i class="el-icon-user"></i></div>
              <div class="info-content">
                <h4>参会对象</h4>
                <p>天文学家、科研人员、高校师生及天文爱好者</p>
              </div>
            </div>
            <div class="info-card">
              <div class="info-icon"><i class="el-icon-chat-dot-square"></i></div>
              <div class="info-content">
                <h4>会议语言</h4>
                <p>中文 / 英文</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 会议主题 -->
        <section class="about-section">
          <h2 class="section-title">会议主题</h2>
          <div class="theme-list">
            <div class="theme-item" v-for="(theme, index) in themes" :key="index">
              <div class="theme-number">{{ String(index + 1).padStart(2, '0') }}</div>
              <div class="theme-content">
                <h4>{{ theme.title }}</h4>
                <p>{{ theme.desc }}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 大会日程简要 -->
        <!-- <section class="about-section">
          <h2 class="section-title">日程安排</h2>
          <div class="schedule-brief">
            <div class="schedule-day">
              <div class="day-header">
                <span class="day-badge">第一天</span>
                <span class="day-date">2025年3月15日（周六）</span>
              </div>
              <ul class="day-items">
                <li><span class="time">08:00-08:30</span><span class="event">签到入场</span></li>
                <li><span class="time">08:30-09:00</span><span class="event">开幕式</span></li>
                <li><span class="time">09:00-12:00</span><span class="event">主旨演讲</span></li>
                <li><span class="time">14:00-17:30</span><span class="event">分论坛 & 海报展示</span></li>
                <li><span class="time">18:00-20:00</span><span class="event">欢迎晚宴</span></li>
              </ul>
            </div>
            <div class="schedule-day">
              <div class="day-header">
                <span class="day-badge">第二天</span>
                <span class="day-date">2025年3月16日（周日）</span>
              </div>
              <ul class="day-items">
                <li><span class="time">08:30-10:30</span><span class="event">主旨演讲</span></li>
                <li><span class="time">10:50-12:00</span><span class="event">青年学者论坛</span></li>
                <li><span class="time">14:00-15:30</span><span class="event">圆桌讨论</span></li>
                <li><span class="time">15:30-16:00</span><span class="event">闭幕式</span></li>
              </ul>
            </div>
          </div>
          <div class="schedule-action">
            <el-button type="primary" @click="$router.push('/schedule')">
              查看完整日程 <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </section> -->

        <!-- 组织机构 -->
        <section class="about-section organizer-section">
          <h2 class="section-title">主办单位</h2>
          <div class="organizer-grid">
            <div class="organizer-card">
              <!-- <h4>主办单位</h4> -->
              <div class="organizer-name">内蒙古大学</div>
              <p>内蒙古大学（Inner Mongolia University），简称内大，位于内蒙古自治区呼和浩特市，是由内蒙古自治区人民政府举办的全日制普通高等学校，是中西部“一省一校”重点支持建设高校，国家“双一流”建设高校。</p>
            </div>
            <div class="organizer-card">
              <!-- <h4>主办单位</h4> -->
              <div class="organizer-name">中国科学院国家天文台</div>
              <p>中国科学院国家天文台成立于2001年4月，系由中国科学院天文领域原四台三站一中心撤并整合而成，总部设于北京，下辖云南天文台、南京天文光学技术研究所、新疆天文台和长春人造卫星观测站等直属机构。</p>
            </div>
            <!-- <div class="organizer-card">
              <h4>支持单位</h4>
              <div class="organizer-name">国家自然科学基金委员会</div>
              <p>支持基础研究和应用基础研究，促进科学技术发展与人才培养。</p>
            </div> -->
          </div>
        </section>

        <!-- 组织委员会 -->
        <section class="about-section">
          <h2 class="section-title">组织委员会</h2>
          <div class="committee-grid">
            <div class="committee-card">
              <h3 class="committee-title">会议科学组织委员会</h3>
              <div class="committee-members">
                <div class="member-row" style="justify-content: center;">
                  <span class="member-name chairman">赵刚（主席）</span>
                  <span class="member-name chairman">韩占文（主席）</span>
                </div>
                <div class="member-row">
                  <span class="member-name">蔡峥</span>
                  <span class="member-name">陈民</span>
                  <span class="member-name">陈雪飞</span>
                  <span class="member-name">陈耀</span>
                  <span class="member-name">崔峻</span>
                  <span class="member-name">董国轩</span>
                  <span class="member-name">樊军辉</span>
                  <span class="member-name">方陶陶</span>
                  <span class="member-name">宫雪非</span>
                  <span class="member-name">姜晓军</span>
                  <span class="member-name">康熙</span>
                  <span class="member-name">孔大力</span>
                  <span class="member-name">孔旭</span>
                  <span class="member-name">李海宁</span>
                  <span class="member-name">李向东</span>
                  <span class="member-name">李玉同</span>
                  <span class="member-name">刘继峰</span>
                  <span class="member-name">刘俊杰</span>
                  <span class="member-name">刘晓为</span>
                  <span class="member-name">罗阿理</span>
                  <span class="member-name">饶长辉</span>
                  <span class="member-name">施勇</span>
                  <span class="member-name">束成钢</span>
                  <span class="member-name">王建立</span>
                  <span class="member-name">王建民</span>
                  <span class="member-name">王炜</span>
                  <span class="member-name">王晓锋</span>
                  <span class="member-name">吴宏</span>
                  <span class="member-name">吴庆文</span>
                  <span class="member-name">吴学兵</span>
                  <span class="member-name">吴雪峰</span>
                  <span class="member-name">袁峰</span>
                  <span class="member-name">俞云伟</span>
                  <span class="member-name">赵公博</span>
                  <span class="member-name">赵国军</span>
                  <span class="member-name">仲佳勇</span>
                  <span class="member-name">朱宗宏</span>
                </div>
              </div>
            </div>

            <div class="committee-card">
              <h3 class="committee-title">会议地方组织委员会</h3>
              <div class="committee-members">
                <div class="member-row" style="justify-content: center;">
                  <span class="member-name chairman">成涛（主席）</span>
                  <!-- <span class="member-name chairman">赵国军（主席）</span> -->
                </div>
                <div class="member-row">
                  <span class="member-name">杜晓东</span>
                  <span class="member-name">周建涛</span>
                  <span class="member-name">李海宁</span>
                  <span class="member-name">刘俊杰</span>
                  <span class="member-name">刘玉娟</span>
                  <span class="member-name">刘全生</span>
                  <span class="member-name">武雅倩</span>
                  <span class="member-name">仲佳勇</span>
                  <span class="member-name">刘正东</span>
                  <span class="member-name">赵国军</span>
                  <span class="member-name">王勤</span>
                  <span class="member-name">王宇</span>
                  <span class="member-name">张琪</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 重要日期 -->
        <section class="about-section">
          <h2 class="section-title">重要日期</h2>
          <div class="timeline" v-if="conferenceInfo">
            <div class="timeline-item" v-if="conferenceInfo.paper_deadline">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">摘要提交截止日期</div>
                <div class="timeline-event">{{ conferenceInfo.paper_deadline }}</div>
              </div>
            </div>
            <div class="timeline-item" v-if="conferenceInfo.early_bird_deadline">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">线上缴费截止日期</div>
                <div class="timeline-event">{{ conferenceInfo.early_bird_deadline }}</div>
              </div>
            </div>
            <div class="timeline-item" v-if="conferenceInfo.registration_deadline">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">报名截止日期</div>
                <div class="timeline-event">{{ conferenceInfo.registration_deadline }}</div>
              </div>
            </div>
            <div class="timeline-item" v-if="conferenceInfo.start_date && conferenceInfo.end_date">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">大会召开时间</div>
                <div class="timeline-event">{{ formatConferenceDate(conferenceInfo.start_date, conferenceInfo.end_date) }}</div>
              </div>
            </div>
          </div>
          <div class="timeline" v-else>
            <div class="timeline-item">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">摘要提交截止日期</div>
                <div class="timeline-event">暂未公布</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">线上注册截止日期</div>
                <div class="timeline-event">暂未公布</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">报名截止日期</div>
                <div class="timeline-event">暂未公布</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-date">大会召开时间</div>
                <div class="timeline-event">暂未公布</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { conferenceApi, scheduleApi } from '@/api'

export default {
  name: 'About',
  data() {
    return {
      loading: false,
      conferenceInfo: null,
      themes: [],
      importantDates: [],
      scheduleBrief: []
    }
  },
  created() {
    this.fetchConferenceInfo()
  },
  methods: {
    async fetchConferenceInfo() {
      this.loading = true
      try {
        const res = await conferenceApi.getDetail(1)
        if (res.data) {
          const data = res.data
          this.conferenceInfo = {
            title: data.title,
            content: data.content || '',
            start_date: data.start_date ,
            end_date: data.end_date,
            location: data.address,
            description: data.description || '',
            attendees: data.attendees || '500+',
            reports: data.reports || '50+',
            experts: data.experts || '20+',
            days: data.days || 2,
            paper_deadline: data.paper_deadline,
            early_bird_deadline: data.early_bird_deadline,
            registration_deadline: data.registration_deadline
          }
          // 解析主题
          if (data.themes) {
            try {
              this.themes = typeof data.themes === 'string' ? JSON.parse(data.themes) : data.themes
            } catch (e) {
              this.useDefaultThemes()
            }
          } else {
            this.useDefaultThemes()
          }
        } else {
          this.useDefaultData()
        }
      } catch (error) {
        console.error('获取会议信息失败:', error)
        this.useDefaultData()
      } finally {
        this.loading = false
      }
    },
    useDefaultData() {
      this.useDefaultThemes()
    },
    useDefaultThemes() {
      this.themes = [
        { title: '银河系与恒星', desc: '银河系形成演化、恒星物理、系外行星科学' },
        { title: '星系和宇宙学', desc: '星系天文学、宇宙大尺度结构、暗物质暗能量、引力波' },
        { title: '天文仪器与巡天', desc: '天文大装置、巡天设备与项目、实验室天体物理' },
        // { title: '恒星物理与演化', desc: '恒星形成、主序演化、晚期演化与超新星爆发机制' },
        // { title: '银河系结构与动力学', desc: '银河系的形成历史、旋臂结构与暗物质晕的研究' },
        // { title: '天文大数据与人工智能', desc: 'AI技术在天文数据处理、目标识别与科学发现中的应用' },
        // { title: '空间天文学', desc: '空间望远镜、X射线天文学与紫外天文观测的最新成果' },
        // { title: '射电天文学', desc: 'FAST、SKA等大型射电望远镜的科学目标与观测进展' }
      ]
    },
    formatConferenceDate(startDate, endDate) {
      // 将日期字符串转换为Date对象
      const start = new Date(startDate)
      const end = new Date(endDate)
      
      // 获取年份
      const year = start.getFullYear()
      
      // 获取月和日
      const startMonth = start.getMonth() + 1 // 月份从0开始，需要+1
      const startDay = start.getDate()
      const endMonth = end.getMonth() + 1
      const endDay = end.getDate()
      
      // 如果是同一个月
      if (startMonth === endMonth) {
        return `${year}年${startMonth}月${startDay}日至${endDay}日`
      } else {
        // 如果不是同一个月
        return `${year}年${startMonth}月${startDay}日至${endMonth}月${endDay}日`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  background: #f8f9fc;
}

.about-section {
  margin-bottom: 60px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 28px;
  font-weight: 600;
  color: #1a237e;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 15px;

  &::after {
    content: '';
    position: absolute;
    // left: 0;
    bottom: 0;
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #1a237e, #7c4dff);
    border-radius: 2px;
  }
}

// 会议概述
.about-intro {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.intro-content {
  p {
    font-size: 16px;
    line-height: 2;
    color: #555;
    margin-bottom: 16px;
    text-align: justify; // 首行缩进

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.intro-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.stat-item {
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  color: #fff;

  .stat-value {
    font-size: 42px;
    font-weight: 700;
    color: #ffd700;
    margin-bottom: 8px;
  }

  .stat-label {
    font-size: 14px;
    opacity: 0.9;
  }
}

// 基本信息
.info-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.info-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(26, 35, 126, 0.1);
  }

  .info-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #1a237e 0%, #7c4dff 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 28px;
      color: #fff;
    }
  }

  .info-content {
    h4 {
      font-size: 18px;
      color: #1a237e;
      margin-bottom: 10px;
    }

    p {
      font-size: 15px;
      color: #666;
      line-height: 1.8;
    }
  }
}

// 会议主题
.theme-list {
  display: grid;
  gap: 20px;
}

.theme-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateX(10px);
    box-shadow: 0 5px 20px rgba(26, 35, 126, 0.1);
  }

  .theme-number {
    font-size: 32px;
    font-weight: 700;
    color: #e0e3f0;
    min-width: 50px;
  }

  .theme-content {
    h4 {
      font-size: 18px;
      color: #1a237e;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
    }
  }
}

// 日程简要
.schedule-brief {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 30px;
}

.schedule-day {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  .day-header {
    background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;

    .day-badge {
      background: #ffd700;
      color: #1a237e;
      padding: 6px 14px;
      border-radius: 15px;
      font-size: 14px;
      font-weight: 600;
    }

    .day-date {
      color: #fff;
      font-size: 16px;
    }
  }

  .day-items {
    list-style: none;
    padding: 20px 24px;

    li {
      display: flex;
      padding: 12px 0;
      border-bottom: 1px dashed #eee;

      &:last-child {
        border-bottom: none;
      }

      .time {
        width: 120px;
        color: #1a237e;
        font-weight: 500;
        font-size: 14px;
      }

      .event {
        color: #555;
        font-size: 15px;
      }
    }
  }
}

.schedule-action {
  text-align: center;
}

// 组织机构
.organizer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.organizer-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  h4 {
    font-size: 14px;
    color: #999;
    margin-bottom: 12px;
    font-weight: 400;
  }

  .organizer-name {
    font-size: 20px;
    font-weight: 600;
    color: #1a237e;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    text-align: left;
    // 首行缩进
    text-indent: 2em;
  }
}

// 组织委员会
.committee-grid {
  display: grid;
  gap: 30px;
}

.committee-card {
  background: #fff;
  border-radius: 16px;
  padding: 35px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

  .committee-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a237e;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e0e3f0;
    text-align: center;
  }

  .committee-members {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .member-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: left;

    &:first-child {
      margin-bottom: 10px;
      padding-bottom: 15px;
      border-bottom: 1px dashed #e0e3f0;
    }
  }

  .member-name {
    display: inline-flex;
    align-items: center;
    padding: 8px 18px;
    background: linear-gradient(135deg, rgba(26, 35, 126, 0.05) 0%, rgba(124, 77, 255, 0.05) 100%);
    border-radius: 20px;
    font-size: 14px;
    color: #555;
    transition: all 0.3s;
    white-space: nowrap;

    &:hover {
      background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
      color: #fff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(26, 35, 126, 0.2);
    }

    // 主席样式
    &.chairman {
      background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
      color: #fff;
      font-weight: 600;

      &:hover {
        background: linear-gradient(135deg, #3949ab 0%, #7c4dff 100%);
      }
    }
  }
}

// 时间线
.timeline {
  position: relative;
  padding-left: 30px;

  &::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 10px;
    bottom: 10px;
    width: 2px;
    background: linear-gradient(180deg, #1a237e, #7c4dff);
  }
}

.timeline-item {
  position: relative;
  padding: 15px 0 15px 30px;

  .timeline-marker {
    position: absolute;
    left: -22px;
    top: 20px;
    width: 16px;
    height: 16px;
    background: #fff;
    border: 3px solid #7c4dff;
    border-radius: 50%;
  }

  .timeline-content {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .timeline-date {
    font-size: 16px;
    font-weight: 600;
    color: #1a237e;
    min-width: 140px;
  }

  .timeline-event {
    font-size: 15px;
    color: #555;
  }
}

// 响应式
@media screen and (max-width: 992px) {
  .about-intro {
    grid-template-columns: 1fr;
  }

  .info-cards {
    grid-template-columns: 1fr;
  }

  .schedule-brief {
    grid-template-columns: 1fr;
  }

  .organizer-grid {
    grid-template-columns: 1fr;
  }

  .committee-card {
    padding: 25px;

    .member-name {
      font-size: 13px;
      padding: 6px 14px;
    }
  }
}

@media screen and (max-width: 576px) {
  .intro-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-item {
    padding: 20px;

    .stat-value {
      font-size: 32px;
    }
  }

  .theme-item {
    flex-direction: column;
    gap: 10px;
  }

  .timeline-item .timeline-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
